import { Typography } from '@prenuvo/halo-web';

export const ClinicOption = ({ address, clinic }: { address: string; clinic: string }) => {
  return (
    <>
      <Typography className="w-full truncate text-left">{clinic}</Typography>
      <Typography
        as="span"
        className="w-full truncate text-neutral-600 dark:text-neutral-500"
        variant="paragraph-sm"
      >
        {address}
      </Typography>
    </>
  );
};
